import React, { Component } from "react";

const createLabeledCheckbox = (
  { groupName, onChange, inputValue = "", hasError },
  value = ""
) => (
  <label
    id={"lbl" + groupName + value}
    htmlFor={groupName + value}
    className="custom-control custom-radio radio2 align-middle"
  >
    <input
      type="radio"
      id={groupName + value}
      onClick={onChange}
      name={groupName}
      value={value.toLowerCase()}
      checked={inputValue.toLowerCase() === value.toLowerCase()}
      className="custom-control-input"
    />
    <span
      className={
        hasError
          ? "is-invalid-label custom-control-description"
          : "custom-control-description"
      }
    >
      {value}
    </span>
    <span className="custom-control-indicator mr-0 ml-2" />
  </label>
);

export default class CheckboxInputGroup extends Component {
  render() {
    return (
      <div className="checkbox-input-group fieldContainer">
        <div className="form-group mt-0">
          <label
            className={
              this.props.hasError
                ? "group-header is-invalid-label"
                : "group-header"
            }
            htmlFor={this.props.groupName + "Set"}
          >
            {this.props.groupHeader}
          </label>
          {this.props.groupDetails ? (
            <div
              className={
                this.props.hasError
                  ? "group-details is-invalid-label"
                  : "group-details"
              }
            >
              {this.props.groupDetails}
            </div>
          ) : (
            ""
          )}

          <div className="form-group label-normal">
            <fieldset id={this.props.groupName + "Set"}>
              {createLabeledCheckbox(this.props, "Yes")}
              {createLabeledCheckbox(this.props, "No")}
            </fieldset>
          </div>
        </div>
      </div>
    );
  }
}
